type FindRecordInApiResponseType = (
  arg0: any,
  arg1: string,
  arg2?: number | string,
) => any

// can be called without an id, to find the first record, usually used for create api responses
export const findRecordInApiResponse: FindRecordInApiResponseType = (
  response,
  modelName,
  id,
) => {
  const records = getRecords(response, modelName)
  if (id) {
    return records[id]
  } else {
    return Object.values(records)[0]
  }
}

type GetRecordsFromApiResponse = (arg0: any, arg1: string) => any

export const getRecordsFromApiResponse: GetRecordsFromApiResponse = (
  response,
  modelName,
) => {
  const records = getRecords(response, modelName)
  return Object.values(records)
}

type GetRecords = (arg0: any, arg1: string) => any

const getRecords: GetRecords = (response, modelName) => {
  return response?.data?.records?.[modelName]?.data || {}
}
